import { LIST_FIELD } from '../type_name'
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: LIST_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        }
    },
    computed: {
        valueHandle() {
            const { items, item_key = 'value', item_text = 'label' } = this.header
            const hash = items.reduce((total, item) => {
                const key = item[item_key]
                total[key] = item[item_text]
                return total
            }, {})
            return hash
        }
    },
    render() {
        return <span>{this.valueHandle[this.value] || '-'}</span> 
        
    }
}